import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-meritum',
    templateUrl: 'hc-meritum.html',
    providers: []
})
export class HcMeritum {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    constructor(public element: ElementRef) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-meritum/hc-meritum.ts